export default {
  'form.entityInfo': '{{entity}} Information',
  'form.required': '{{field}} is required',
  'form.inputPlaceholder': 'Enter {{field}}',
  'form.selectPlaceholder': 'Select {{field}}',
  'form.invalidLayout': 'Not compatible layout',
  'form.cloneFrom': 'Clone from {{instance}}',
  'form.image': '{{type}} Image',
  'form.image.filename': 'Image Name',
  'form.image.altText': 'Image Alternative Text',
  'form.fullName': 'Full Name',
  'form.firstName': 'First Name',
  'form.lastName': 'Last Name',
  'form.middleName': 'Middle Name',
  'form.honorificName': 'Honorific Name',
  'form.birthdate': 'Birthdate',
  'form.genderIdentity': 'Gender Identity',
  'form.entity': 'Entity',
  'form.entityKey': 'Entity Key',
  'form.contentKey': 'Content Key',
  'form.upload': 'Upload',
  'form.selectFile': 'Select File',
  'form.uploadText': 'Click or drag file to this area to upload',
  'form.uploadHint':
    'Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files',
  'form.uploadTypeError': '{name} is not a valid file type',
  'form.uploadDimsError':
    'Maximum image dimension (Width x Height) {width}px x {height}px',
  'form.translate': 'Translate Keys',
  'form.helper': 'Show Helper',
  'form.license': 'License',
  'form.license.type': 'License Type',
  'form.license.number': 'License Id',
  'form.licenses': 'Licenses',
  'form.title': 'Title',
  'form.number': 'Number',
  'form.description': 'Description',
  'form.shortDescription': 'Short Description',
  'form.status': 'Status',
  'form.tags': 'Tags',
  'form.target': 'Target',
  'form.link': 'Link Address',
  'form.logo': 'Logo',
  'form.logos': 'Logos',
  'form.logo.primary': 'Primary Logo',
  'form.email.type': 'Email Type',
  'form.email': 'Email Address',
  'form.emails': 'Email Addresses',
  'form.countryCode': 'Country Code',
  'form.phone': 'Phone Number',
  'form.phones': 'Phone Numbers',
  'form.phone.type': 'Device Type',
  'form.phone.businessType': 'Business Related',
  'form.phone.ability': 'Phone Type',
  'form.phone.extension': 'Ext.',
  'form.email.primary': 'Primary Email Address',
  'form.email.primary.description':
    'will be used for account-related notifications and can be used for password resets.',
  'form.private.helper':
    'Private {{type}} cannot be designated as Public Primary {{type}} within our system',
  'form.billing.helper':
    'Private {{type}} cannot be designated as Public Billing {{type}} within our system',
  'form.unverified.helper':
    'Unverified {{type}} cannot be designated as Public Primary {{type}} within our system',
  'form.phone.primary': 'Primary Phone Number',
  'form.phone.primary.description': 'will be used for account-related calls.',
  'form.email.exists': 'Email Address already exists',
  'form.phone.exists': 'Phone Number already exists',
  'form.preview': 'Preview',
  'form.documentUrl': 'Document URL',
  'form.imgUrl': 'Image URL',
  'form.embedUrl': 'Embed URL',
  'form.ownerName': 'Owner Name',
  'form.issueDate': 'Issue Date',
  'form.expirationDate': 'Expiration Date',
  'form.renewalDate': 'Renewal Date',
  'form.createdBy': 'Created by',
  'form.updatedBy': 'Updated by',
  'form.createdAt': 'Created at',
  'form.lastUsed': 'Last Used',
  'form.updatedAt': 'Updated at',
  'form.invitedAt': 'Invited at',
  'form.today': 'Today',
  'form.tomorrow': 'Tomorrow',
  'form.days': '{{count}} days',
  'form.customize': 'Customize',
  'form.noExpiration': 'No Expiration',
  'form.nameHelp':
    'Your {{type}} may appear around WelcomeHome where you contribute or are mentioned.',
  'form.type.public': 'Public',
  'form.type.primary': 'Primary',
  'form.type.draft': 'Draft',
  'form.type.private': 'Private',
  'form.type.minor': 'Minor',
  'form.assets': 'Assets ({{amount}})',
  'form.validation.min': '{{entity}} must be minimum {min} characters',
  'form.metadata': 'Metadata',
  'form.section': 'Section',
  'form.private': 'Private',
  'form.public': 'Public',
  'form.source': 'Source',
  'form.switch.yes': 'Yes',
  'form.switch.no': 'No',
  'form.phone.invalidPhone': 'Invalid Phone Number',
  'form.phone.countryCode': 'Country Code',
  'form.approve': 'Approve',
  'form.toHide': 'to Hide',
  'form.toShow': 'to Show',
  'form.confirm': 'Confirm',
  'form.name': '{{entity}} Name',
  'form.type': 'Type',
  'form.typeOf': '{{entity}} Type',
  'form.verify': 'Verify {{type}}',
  'form.enterField': 'Enter {{type}} here',
  'form.tag.helper': 'Add keywords to help categorize or identify the feature',
  'form.metadata.helper':
    'System-generated info: who created or last updated this item and when',

  'form.credits.modal.title': 'Grant Credits',
  'form.credits.modal.ok': 'Grant',
  'form.credits.tenant': 'Tenant',
  'form.credits.tenant.tooltip':
    'The tenant (organization) whose wallet will be credited.',
  'form.credits.tenant.placeholder': 'Select a tenant',
  'form.credits.tenant.noTenants': 'No tenants found.',
  'form.credits.tenant.createLink': 'Create a tenant first',
  'form.credits.userId': 'User ID',
  'form.credits.userId.tooltip':
    'The user whose wallet receives the credits. Defaults to your own UID — change this to grant credits to a different user.',
  'form.credits.userId.extra':
    'Pre-filled with your UID. Edit to target another user.',
  'form.credits.userId.placeholder': 'Firebase UID of the recipient',
  'form.credits.amount': 'Amount',
  'form.credits.amount.tooltip':
    'Number of credits to apply. Must be a positive integer.',
  'form.credits.kind': 'Kind',
  'form.credits.kind.tooltip':
    'GRANT adds credits; DEBIT removes them; REFUND returns previously debited credits.',
  'form.credits.kind.grant': 'GRANT — add credits to wallet',
  'form.credits.kind.debit': 'DEBIT — remove credits from wallet',
  'form.credits.kind.refund': 'REFUND — return previously debited credits',
  'form.credits.kind.adjustment': 'ADJUSTMENT — manual balance correction',
  'form.credits.referenceId': 'Reference ID',
  'form.credits.referenceId.tooltip':
    'External reference for traceability — e.g. invoice ID, order ID, or support ticket number.',
  'form.credits.referenceId.extra':
    'Use any meaningful external ID (invoice, order, ticket).',
  'form.credits.referenceId.placeholder': 'e.g. INV-2024-001',
  'form.credits.operation': 'Operation',

  'form.entitlements.operation': 'Operation',
  'form.entitlements.kind': 'Kind',
  'form.entitlements.costPerUnit': 'Cost / Unit',
  'form.entitlements.version': 'Version',
  'form.entitlements.isActive': 'Active',

  'form.subscription.monthlyCredits': 'Monthly Credits',
};
